import { jsx as _jsx } from "react/jsx-runtime";
import { ModalBody as ChakraModalBody, } from '@chakra-ui/react';
/**
 * React component that houses the main content of the modal.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/modal
 */
export function ModalBody({ children, ...props }) {
    return _jsx(ChakraModalBody, { ...props, children: children });
}
//# sourceMappingURL=modalBody.js.map